interface Props {
  url: string;
}

export default function SMSImageAttachment({ url }: Props) {
  return (
    <img src={url} className="sms-image" alt="" height="auto" width="auto" />
  );
}
